///////////////////////////////////////////
// This is a generated file, DO NOT EDIT //
///////////////////////////////////////////

export const screens = { sm: '640px', md: '768px', lg: '1024px', xl: '1280px' }
export type ScreensType = keyof typeof screens

export const fontSize = {
  'micro': ['9px', '11.7px'],
  '2xs': ['11px', '8px'],
  'xs': ['12px', '16px'],
  'sm': ['13px', '16px'],
  'md': ['14px', '17px'],
  'base': ['15px', '24px'],
  'lg': ['18px', '24px'],
  'xl': ['20px', '24px'],
  '2xl': ['22px', '24px'],
  '3xl': ['25px', '32px'],
  '4xl': ['30px', '32px'],
  '5xl': ['35px', '40px'],
  '6xl': ['50px', '60px'],
  '2xsmall': ['10px', { lineHeight: '12px' }],
  'xsmall': ['11px', { lineHeight: '13px', letterSpacing: '-0.01em' }],
  'small': ['12px', { lineHeight: '14px', letterSpacing: '-0.01em' }],
  'default': ['13px', { lineHeight: '16px', letterSpacing: '-0.02em' }],
  'large': ['14px', { lineHeight: '16px', letterSpacing: '-0.03em' }],
  'xlarge': ['16px', { lineHeight: '20px', letterSpacing: '-0.02em' }],
  '2xlarge': ['18px', { lineHeight: '22px', letterSpacing: '-0.02em' }],
  '3xlarge': ['22px', { lineHeight: '28px', letterSpacing: '-0.02em' }],
  '4xlarge': ['28px', { lineHeight: '32px', letterSpacing: '-0.02em' }],
  '1px': ['1px'],
  '2px': ['2px'],
  '3px': ['3px'],
  '4px': ['4px'],
  '5px': ['5px'],
  '6px': ['6px'],
  '7px': ['7px'],
  '8px': ['8px'],
  '9px': ['9px'],
  '10px': ['10px'],
  '11px': ['11px'],
  '12px': ['12px'],
  '13px': ['13px'],
  '14px': ['14px'],
  '15px': ['15px'],
  '16px': ['16px'],
  '17px': ['17px'],
  '18px': ['18px'],
  '19px': ['19px'],
  '20px': ['20px'],
  '21px': ['21px'],
  '22px': ['22px'],
  '23px': ['23px'],
  '24px': ['24px'],
  '25px': ['25px'],
  '26px': ['26px'],
  '27px': ['27px'],
  '28px': ['28px'],
  '29px': ['29px'],
  '30px': ['30px'],
  '31px': ['31px'],
  '32px': ['32px'],
  '33px': ['33px'],
  '34px': ['34px'],
  '35px': ['35px'],
  '36px': ['36px'],
  '37px': ['37px'],
  '38px': ['38px'],
  '39px': ['39px'],
  '40px': ['40px'],
  '41px': ['41px'],
  '42px': ['42px'],
  '43px': ['43px'],
  '44px': ['44px'],
  '45px': ['45px'],
  '46px': ['46px'],
  '47px': ['47px'],
  '48px': ['48px'],
  '49px': ['49px'],
  '50px': ['50px'],
  '51px': ['51px'],
  '52px': ['52px'],
  '53px': ['53px'],
  '54px': ['54px'],
  '55px': ['55px'],
  '56px': ['56px'],
  '57px': ['57px'],
  '58px': ['58px'],
  '59px': ['59px'],
  '60px': ['60px'],
}
export type FontSizeType = keyof typeof fontSize

export const lineHeight = {
  'normal': 'normal',
  'none': '1',
  'base': '8px',
  '1em': '1em',
  'lg': '16px',
  'xl': '24px',
  '2xl': '32px',
  '3xl': '48px',
  '4xl': '56px',
  '5xl': '64px',
  '125%': '125%',
  '140%': '140%',
  '1px': ['1px'],
  '2px': ['2px'],
  '3px': ['3px'],
  '4px': ['4px'],
  '5px': ['5px'],
  '6px': ['6px'],
  '7px': ['7px'],
  '8px': ['8px'],
  '9px': ['9px'],
  '10px': ['10px'],
  '11px': ['11px'],
  '12px': ['12px'],
  '13px': ['13px'],
  '14px': ['14px'],
  '15px': ['15px'],
  '16px': ['16px'],
  '17px': ['17px'],
  '18px': ['18px'],
  '19px': ['19px'],
  '20px': ['20px'],
  '21px': ['21px'],
  '22px': ['22px'],
  '23px': ['23px'],
  '24px': ['24px'],
  '25px': ['25px'],
  '26px': ['26px'],
  '27px': ['27px'],
  '28px': ['28px'],
  '29px': ['29px'],
  '30px': ['30px'],
  '31px': ['31px'],
  '32px': ['32px'],
  '33px': ['33px'],
  '34px': ['34px'],
  '35px': ['35px'],
  '36px': ['36px'],
  '37px': ['37px'],
  '38px': ['38px'],
  '39px': ['39px'],
  '40px': ['40px'],
}
export type LineHeightType = keyof typeof lineHeight

export const fontWeight = {
  thin: 100,
  light: 200,
  normal: 300,
  medium: 400,
  semibold: 500,
  bold: 600,
  extrabold: 700,
  black: 800,
  heavy: 800,
}
export type FontWeightType = keyof typeof fontWeight

export const spacing = {
  '0': '0px',
  '1': '5px',
  '2': '10px',
  '3': '15px',
  '4': '20px',
  '5': '25px',
  '6': '30px',
  '7': '35px',
  '8': '40px',
  '9': '45px',
  '10': '50px',
  '11': '55px',
  '12': '60px',
  '13': '65px',
  '14': '70px',
  '15': '75px',
  '16': '80px',
  '17': '85px',
  '18': '90px',
  '19': '95px',
  '20': '100px',
  '21': '105px',
  '22': '110px',
  '23': '115px',
  '24': '120px',
  '25': '125px',
  '26': '130px',
  '27': '135px',
  '28': '140px',
  '29': '145px',
  '30': '150px',
  '31': '155px',
  '32': '160px',
  '33': '165px',
  '34': '170px',
  '35': '175px',
  '36': '180px',
  '37': '185px',
  '38': '190px',
  '39': '195px',
  '40': '200px',
  '41': '205px',
  '42': '210px',
  '43': '215px',
  '44': '220px',
  '45': '225px',
  '46': '230px',
  '47': '235px',
  '48': '240px',
  '49': '245px',
  '50': '250px',
  '51': '255px',
  '52': '260px',
  '53': '265px',
  '54': '270px',
  '55': '275px',
  '56': '280px',
  '57': '285px',
  '58': '290px',
  '59': '295px',
  '60': '300px',
  '61': '305px',
  '62': '310px',
  '63': '315px',
  '64': '320px',
  '65': '325px',
  '66': '330px',
  '67': '335px',
  '68': '340px',
  '69': '345px',
  '70': '350px',
  '71': '355px',
  '72': '360px',
  '73': '365px',
  '74': '370px',
  '75': '375px',
  '76': '380px',
  '77': '385px',
  '78': '390px',
  '79': '395px',
  '80': '400px',
  '81': '405px',
  '82': '410px',
  '83': '415px',
  '84': '420px',
  '85': '425px',
  '86': '430px',
  '87': '435px',
  '88': '440px',
  '89': '445px',
  '90': '450px',
  '91': '455px',
  '92': '460px',
  '93': '465px',
  '94': '470px',
  '95': '475px',
  '96': '480px',
  '97': '485px',
  '98': '490px',
  '99': '495px',
  '100': '500px',
  '101': '505px',
  '102': '510px',
  '103': '515px',
  '104': '520px',
  '105': '525px',
  '106': '530px',
  '107': '535px',
  '108': '540px',
  '109': '545px',
  '110': '550px',
  '111': '555px',
  '112': '560px',
  '113': '565px',
  '114': '570px',
  '115': '575px',
  '116': '580px',
  '117': '585px',
  '118': '590px',
  '119': '595px',
  '120': '600px',
  '121': '605px',
  '122': '610px',
  '123': '615px',
  '124': '620px',
  '125': '625px',
  '126': '630px',
  '127': '635px',
  '128': '640px',
  '129': '645px',
  '130': '650px',
  '131': '655px',
  '132': '660px',
  '133': '665px',
  '134': '670px',
  '135': '675px',
  '136': '680px',
  '137': '685px',
  '138': '690px',
  '139': '695px',
  '140': '700px',
  '141': '705px',
  '142': '710px',
  '143': '715px',
  '144': '720px',
  '145': '725px',
  '146': '730px',
  '147': '735px',
  '148': '740px',
  '149': '745px',
  '0.5': '3px',
  '1px': '1px',
  '2px': '2px',
  '3px': '3px',
  '4px': '4px',
  '5px': '5px',
  '6px': '6px',
  '7px': '7px',
  '8px': '8px',
  '9px': '9px',
  '10px': '10px',
  '11px': '11px',
  '12px': '12px',
  '13px': '13px',
  '14px': '14px',
  '15px': '15px',
  '16px': '16px',
  '17px': '17px',
  '18px': '18px',
  '19px': '19px',
  '20px': '20px',
  '21px': '21px',
  '22px': '22px',
  '23px': '23px',
  '24px': '24px',
  '25px': '25px',
  '26px': '26px',
  '27px': '27px',
  '28px': '28px',
  '29px': '29px',
  '30px': '30px',
  '31px': '31px',
  '32px': '32px',
  '33px': '33px',
  '34px': '34px',
  '35px': '35px',
  '36px': '36px',
  '37px': '37px',
  '38px': '38px',
  '39px': '39px',
  '40px': '40px',
}
export type SpacingType = keyof typeof spacing

export const colors = {
  'current': 'currentColor',
  'transparent': 'transparent',
  'white': '#FFFFFF',
  'black': '#000000',
  'gray-10': '#F0F0F0',
  'gray-20': '#E2E2E2',
  'gray-30': '#D3D3D3',
  'gray-40': '#C5C5C5',
  'gray-50': '#B7B7B7',
  'gray-60': '#A9A9A9',
  'gray-70': '#9C9C9C',
  'gray-80': '#8E8E8E',
  'gray-90': '#818181',
  'gray-100': '#6C6D72',
  'gray-200': '#606167',
  'gray-300': '#54565B',
  'gray-400': '#494950',
  'gray-500': '#3D3D44',
  'gray-600': '#35353D',
  'gray-700': '#2D2D31',
  'gray-800': '#26252A',
  'gray-850': '#202025',
  'gray-900': '#1B1B20',
  'gray-950': '#141417',
  'brand-50': '#7FFFFF',
  'brand-100': '#57E2FF',
  'brand-200': '#20C5FF',
  'brand-300': '#00A7E7',
  'brand-400': '#008BC9',
  'brand-500': '#0070AC',
  'brand-600': '#00568F',
  'brand-700': '#003E74',
  'brand-800': '#002759',
  'brand-900': '#00123F',
  'brand-DEFAULT': '#00BEFF',
  'brand-base': '#00BEFF',
  'red-50': '#FFCAC8',
  'red-100': '#FFABAB',
  'red-200': '#FF8E8E',
  'red-300': '#F77073',
  'red-400': '#D75359',
  'red-500': '#B63640',
  'red-600': '#961229',
  'red-700': '#770013',
  'red-800': '#590000',
  'red-900': '#410000',
  'red-DEFAULT': '#D35056',
  'red-brand': '#FF4F4F',
  'green-50': '#8DFFCD',
  'green-100': '#6DECB0',
  'green-200': '#4CCE93',
  'green-300': '#24B077',
  'green-400': '#00935D',
  'green-500': '#007744',
  'green-600': '#005B2B',
  'green-700': '#004115',
  'green-800': '#002B00',
  'green-900': '#001B00',
  'green-DEFAULT': '#2EB67D',
  'yellow-50': '#FFEB57',
  'yellow-100': '#FFCD37',
  'yellow-200': '#E4B009',
  'yellow-300': '#C39400',
  'yellow-400': '#A37900',
  'yellow-500': '#855F00',
  'yellow-600': '#684600',
  'yellow-700': '#4F2E00',
  'yellow-800': '#3D1600',
  'yellow-900': '#320000',
  'yellow-DEFAULT': '#FEC72F',
  'purple-50': '#FFD8FF',
  'purple-100': '#F0BAFF',
  'purple-200': '#D09DFF',
  'purple-300': '#B180FF',
  'purple-400': '#9265E9',
  'purple-500': '#744ACB',
  'purple-600': '#5530AD',
  'purple-700': '#351690',
  'purple-800': '#090074',
  'purple-900': '#000059',
  'purple-DEFAULT': '#A878FF',
  'orange-50': '#FFD283',
  'orange-100': '#FFB467',
  'orange-200': '#FF974B',
  'orange-300': '#F07A2F',
  'orange-400': '#CE5F11',
  'orange-500': '#AD4400',
  'orange-600': '#8D2800',
  'orange-700': '#6F0600',
  'orange-800': '#540000',
  'orange-900': '#410000',
  'orange-DEFAULT': '#F57F34',
  'surface-brand': '#1A1A1A',
  'surface-lower': '#121314',
  'surface-base': '#1D1E1F',
  'surface-low': '#212124',
  'surface-middle': '#26262A',
  'surface-upper': '#29292E',
  'surface-high': '#343435',
  'surface-higher': '#4A4B4B',
  'surface-highest': '#616162',
  'glyph-base': '#FFFFFF',
  'glyph-light': '#C2C2C2',
  'glyph-lighter': '#969696',
  'glyph-lightest': '#505050',
  'link': '#00BEFF',
  'info-error': '#eb3341',
  'info-danger': '#F77F25',
  'info-warn': '#FFC82F',
  'info-ok': '#00974F',
  'info-notice': '#0180FF',
  'accent-1': '#FF5D69',
  'accent-2': '#07F5AF',
  'accent-3': '#04D372',
  'accent-4': '#8451F5',
}
export type ColorsType = keyof typeof colors

export const borderRadius = {
  'none': '0',
  'sm': '0.125rem',
  'DEFAULT': '0.25rem',
  'md': '0.375rem',
  'lg': '0.5rem',
  'xl': '0.75rem',
  '2xl': '1rem',
  '3xl': '1.5rem',
  'full': '9999px',
  'base': '5px',
  'small': '2.5px',
  'large': '10px',
  '36px': '36px',
}
export type BorderRadiusType = keyof typeof borderRadius

export const borderWidth = {
  '0': '0px',
  '1': '1px',
  '2': '2px',
  '3': '3px',
  '4': '4px',
  '8': '8px',
  'DEFAULT': '1px',
  '1.5': '1.5px',
}
export type BorderWidthType = keyof typeof borderWidth

export const boxShadow = {
  'sm': '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  'DEFAULT': '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  'md': '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  'lg': '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  'xl': '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
  '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  'inner': 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  'none': 'none',
  'outline': '0 0 0 1px #00BEFF',
  'contrast': '0 0 0 1px rgba(0,0,0,0.1), 0 0 0 2px rgba(0,0,0,0.1)',
  'modal': '0px 5px 20px rgba(0, 0, 0, 0.35)',
  'dropdown': '0px 15px 25px rgba(0, 0, 0, 0.25)',
  'form-toggle': '0px 1px 2px rgba(0,0,0,0.2)',
  'mobile-panel': '0px -20px 50px rgba(0, 0, 0, 0.25)',
  'dreamten-table-row': '10px 0 0 #26252A, -10px 0 0 #26252A',
}
export type BoxShadowType = keyof typeof boxShadow

export const fontFamily = {
  sans: [
    'Inter',
    'system-ui',
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Helvetica Neue',
    'Arial',
    'Noto Sans',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji',
  ],
  serif: ['ui-serif', 'Georgia', 'Cambria', '"Times New Roman"', 'Times', 'serif'],
  mono: ['IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Courier', 'monospace'],
}
export type FontFamilyType = keyof typeof fontFamily

export const opacity = {
  '0': '0',
  '5': '0.05',
  '10': '0.1',
  '15': '0.15',
  '20': '0.2',
  '25': '0.25',
  '30': '0.3',
  '40': '0.4',
  '50': '0.5',
  '60': '0.6',
  '70': '0.7',
  '75': '0.75',
  '80': '0.8',
  '90': '0.9',
  '95': '0.95',
  '100': '1',
}
export type OpacityType = keyof typeof opacity

export const zIndex = {
  '0': '0',
  '10': '10',
  '20': '20',
  '30': '30',
  '40': '40',
  '50': '50',
  'auto': 'auto',
  'panel': 10,
  'pin': 20,
  'modal': 30,
  'menu': 40,
  'tooltip': 50,
  'max': 2147483647,
}
export type ZIndexType = keyof typeof zIndex
